import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import SpecialistAssignmentBoard from "./SpecialistAssignmentBoard";
import FlowEngineGlobalGate from "../specialist-flow-engine/FlowEngineGlobalGate";
import { isLiaisonInboxEnabled } from "../../app/helpers/flowEngineConfigHelper";

const SpecialistLiaisonSelectionScreen = () => {
  const configuration = useSelector((state) => state.configuration);

  if (!isLiaisonInboxEnabled(configuration)) {
    return <Navigate to="/specialist-role-selection" replace />;
  }

  return (
    <FlowEngineGlobalGate>
      <SpecialistAssignmentBoard
        roleKey="liaison"
        titleKey="specialist.selection.liaison.title"
        defaultTitle="Bandeja del Enlace"
      />
    </FlowEngineGlobalGate>
  );
};

export default SpecialistLiaisonSelectionScreen;
